import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * SEO component for dynamic meta tags
 * @param {Object} props - Component props
 * @param {string} props.title - Page title
 * @param {string} props.description - Page description
 * @param {string} props.keywords - Page keywords (comma separated)
 * @param {string} props.canonicalUrl - Canonical URL for the page
 * @param {string} props.ogType - Open Graph type (default: website)
 * @param {string} props.ogImage - Open Graph image URL
 * @param {string} props.twitterCard - Twitter card type (default: summary_large_image)
 */
const SEO = ({
  title = "Diviti Adora | Infrared & Red Light Studio",
  description = "Diviti Adora Infrared Sauna & Red Light Studio in Oro Valley. Experience detoxification, rejuvenation, and holistic wellness through infrared sauna, red light therapy, chromotherapy, and halotherapy.",
  keywords = "infrared sauna Oro Valley AZ, red light therapy near Oro Valley, halotherapy Tucson, chromotherapy Marana AZ, cold plunge Oro Valley, wellness center Tucson Arizona, detox spa Marana, holistic healing Oro Valley, best sauna Tucson, RLT services Marana AZ, Oro Valley red light therapy studio, Tucson infrared sauna sessions, infrared sauna for detoxification Oro Valley, red light therapy for skin rejuvenation Tucson, halotherapy for breathing problems Arizona, chromotherapy for stress relief Marana, cold plunge for muscle recovery Oro Valley, infrared sauna weight loss benefits, RLT for anti-aging Tucson, salt therapy for sinus relief, holistic therapy for pain relief Arizona, improve circulation sauna Oro Valley, boost immune system red light therapy, full spectrum infrared sauna Oro Valley, LED red light therapy facials Tucson, dry salt therapy for allergies Marana, natural detox methods Oro Valley, how to improve skin clarity Tucson, holistic weight management Marana, therapy for chronic pain Arizona, reduce inflammation naturally Oro Valley, seasonal allergy relief Tucson halotherapy, mind body wellness Oro Valley, preventative health solutions Tucson, natural healing therapies Arizona, self-care spa Oro Valley, alternative wellness center Tucson, health and wellness studio Marana",
  canonicalUrl = "https://divitiadorastudio.com",
  ogType = "website",
  ogImage = "/logo512.png",
  twitterCard = "summary_large_image",
}) => {
  // Construct the full canonical URL
  const fullCanonicalUrl = canonicalUrl.startsWith("http")
    ? canonicalUrl
    : `https://divitiadorastudio.com${canonicalUrl}`;

  // Construct the full OG image URL
  const fullOgImageUrl = ogImage.startsWith("http")
    ? ogImage
    : `https://divitiadorastudio.com${ogImage}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={fullCanonicalUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={fullCanonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullOgImageUrl} />

      {/* Twitter */}
      <meta property="twitter:card" content={twitterCard} />
      <meta property="twitter:url" content={fullCanonicalUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={fullOgImageUrl} />
    </Helmet>
  );
};

export default SEO;
